export default "__VITE_ASSET__BmdcldOW__"